module.exports = __webpack_public_path__ + "img/gallery02.2de5d150.jpg";